export function authNamespace(http) {
    return {
        /** Exchange credentials for a token (raw body; no token required). */
        login(email, password) {
            return http.post('/login', { body: { email, password }, raw: true });
        },
        /** Invalidate the current token server-side. */
        logout() {
            return http.post('/logout');
        },
        /** Current user → unwraps to `{ user }`. */
        me() {
            return http.get('/me');
        },
        /** Refresh the token (raw body). */
        refresh() {
            return http.post('/refresh', { raw: true });
        },
    };
}
//# sourceMappingURL=auth-endpoints.js.map